module.exports = __webpack_public_path__ + "img/search-by-face.34aaa55b.jpg";